// Quản lý SHOPS (cửa hàng) — M2 refactor 2026-04-22.
// Shop = cửa hàng vật lý (Hello Con HP / HN / …).
// 1 shop gắn với N máy kiosk + N NV.
// Disable shop: revoke toàn bộ máy + NV của shop (backend lo, frontend chỉ confirm).
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { api } from '../lib/api.js';
import { showConfirm } from '../lib/dialogs.js';

export default function AdminShopsPage() {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [editing, setEditing] = useState(null);

  async function reload() {
    setLoading(true);
    try {
      const { shops } = await api.adminShops();
      setShops(shops);
    } catch (err) {
      toast.error(err.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { reload(); }, []);

  async function act(fn, msg) {
    try { await fn(); toast.success(msg); reload(); }
    catch (err) { toast.error(err.data?.error || err.message); }
  }

  return (
    <div className="min-h-full p-4 md:p-6">
      <div className="max-w-5xl mx-auto">
        <Link to="/admin" className="text-sm text-slate-500 hover:text-slate-700">← Trang admin</Link>
        <div className="flex items-start justify-between gap-3 mt-2 flex-wrap">
          <div className="min-w-0 flex-1">
            <h1 className="text-xl md:text-2xl font-semibold text-brand-700">Quản lý cửa hàng</h1>
            <p className="text-xs text-slate-500 mt-1">
              Mỗi shop gắn N máy kiosk + N NV. Disable shop sẽ vô hiệu hoá toàn bộ máy & NV thuộc shop.
            </p>
          </div>
          <button onClick={() => setShowCreate(true)} className="tap-feedback px-4 py-2.5 rounded-lg bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium shadow-sm w-full sm:w-auto">
            + Thêm shop
          </button>
        </div>

        <div className="mt-4 bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
              <tr>
                {/* M148b: hide ID + Địa chỉ + Máy/NV count mobile */}
                <th className="px-3 py-2 hidden md:table-cell">ID</th>
                <th className="px-3 py-2">Mã</th>
                <th className="px-3 py-2">Tên</th>
                <th className="px-3 py-2 hidden md:table-cell">Địa chỉ</th>
                <th className="px-3 py-2 text-center hidden md:table-cell">Máy</th>
                <th className="px-3 py-2 text-center hidden md:table-cell">NV</th>
                <th className="px-3 py-2">Status</th>
                <th className="px-3 py-2 text-right">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} className="px-3 py-6 text-center text-slate-400">Đang tải…</td></tr>
              ) : shops.length === 0 ? (
                <tr><td colSpan={8} className="px-3 py-6 text-center text-slate-400">Chưa có shop nào — bấm "+ Thêm shop" để tạo</td></tr>
              ) : shops.map(s => (
                <tr key={s.id} className="border-t border-slate-100 align-top">
                  <td className="px-3 py-2 font-mono text-xs hidden md:table-cell">{s.id}</td>
                  <td className="px-3 py-2 font-mono font-medium">{s.code}</td>
                  <td className="px-3 py-2">{s.name}</td>
                  <td className="px-3 py-2 text-xs text-slate-600 hidden md:table-cell">{s.address || <span className="text-slate-300">—</span>}</td>
                  <td className="px-3 py-2 text-center text-xs hidden md:table-cell">{s.users_count ?? '?'}</td>
                  <td className="px-3 py-2 text-center text-xs hidden md:table-cell">{s.employees_count ?? '?'}</td>
                  <td className="px-3 py-2">
                    <span className={`text-xs px-2 py-0.5 rounded ${s.status === 'active' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-600'}`}>
                      {s.status}
                    </span>
                  </td>
                  <td className="px-3 py-2 text-right">
                    <div className="flex flex-wrap gap-1 justify-end">
                      <button onClick={() => setEditing(s)} className="text-xs px-2 py-1 rounded bg-slate-100 text-slate-700 hover:bg-slate-200">Sửa</button>
                      {s.status === 'active' ? (
                        <button
                          onClick={async () => {
                            const ok = await showConfirm({
                              title: 'Disable shop',
                              message: `Disable shop "${s.name}"?\nMọi máy & NV của shop sẽ bị thu hồi phiên.`,
                              confirmText: 'Disable',
                              dangerous: true,
                            });
                            if (!ok) return;
                            act(() => api.adminDisableShop(s.id), 'Đã disable shop');
                          }}
                          className="text-xs px-2 py-1 rounded bg-amber-100 text-amber-700 hover:bg-amber-200"
                        >Disable</button>
                      ) : (
                        <button onClick={() => act(() => api.adminEnableShop(s.id), 'Đã enable shop')} className="text-xs px-2 py-1 rounded bg-emerald-100 text-emerald-700 hover:bg-emerald-200">Enable</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showCreate && (
          <ShopEditModal
            mode="create"
            onClose={() => setShowCreate(false)}
            onSaved={() => { setShowCreate(false); reload(); }}
          />
        )}
        {editing && (
          <ShopEditModal
            mode="edit"
            initial={editing}
            onClose={() => setEditing(null)}
            onSaved={() => { setEditing(null); reload(); }}
          />
        )}
      </div>
    </div>
  );
}

function ShopEditModal({ mode, initial, onClose, onSaved }) {
  const [form, setForm] = useState({
    code: initial?.code || '',
    name: initial?.name || '',
    address: initial?.address || '',
  });
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === 'create') {
        await api.adminCreateShop({
          code: form.code.trim(),
          name: form.name.trim(),
          address: form.address.trim() || null,
        });
        toast.success('Đã tạo shop');
      } else {
        const patch = {};
        if (form.name.trim() !== initial.name) patch.name = form.name.trim();
        if ((form.address.trim() || null) !== (initial.address || null)) patch.address = form.address.trim() || null;
        if (Object.keys(patch).length === 0) {
          toast('Không có thay đổi');
          onClose();
          return;
        }
        await api.adminUpdateShop(initial.id, patch);
        toast.success('Đã cập nhật');
      }
      onSaved();
    } catch (err) {
      toast.error(err.data?.error || err.message);
    } finally {
      setBusy(false);
    }
  }

  const update = (k) => (e) => {
    const v = e.target.value;
    setForm(f => ({ ...f, [k]: v }));
  };

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-20 p-4">
      <form onSubmit={submit} className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 space-y-3">
        <h3 className="font-semibold text-lg">{mode === 'create' ? 'Tạo shop mới' : `Sửa shop: ${initial.name}`}</h3>
        <label className="block">
          <span className="block text-sm font-medium text-slate-700">
            Mã (ví dụ: hp, hn) — chỉ chữ thường, số, - _ {mode === 'edit' && <em className="text-xs text-slate-400">(không sửa được)</em>}
          </span>
          <input
            required
            value={form.code}
            onChange={update('code')}
            disabled={mode === 'edit'}
            placeholder="hp"
            className="mt-1 w-full px-3 py-2 rounded-lg border border-slate-300 font-mono disabled:bg-slate-50 disabled:text-slate-500"
          />
        </label>
        <label className="block">
          <span className="block text-sm font-medium text-slate-700">Tên đầy đủ</span>
          <input
            required
            value={form.name}
            onChange={update('name')}
            placeholder="Hello Con Hải Phòng"
            className="mt-1 w-full px-3 py-2 rounded-lg border border-slate-300 focus:border-brand-500 focus:ring-2 focus:ring-brand-100 outline-none"
          />
        </label>
        <label className="block">
          <span className="block text-sm font-medium text-slate-700">Địa chỉ (tuỳ chọn)</span>
          <input
            value={form.address}
            onChange={update('address')}
            placeholder="123 Lê Hồng Phong, Ngô Quyền, Hải Phòng"
            className="mt-1 w-full px-3 py-2 rounded-lg border border-slate-300 focus:border-brand-500 focus:ring-2 focus:ring-brand-100 outline-none"
          />
        </label>
        <div className="flex gap-2 pt-2">
          <button type="button" onClick={onClose} className="flex-1 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 text-sm font-medium">Huỷ</button>
          <button type="submit" disabled={busy} className="flex-1 py-2 rounded-lg bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium disabled:opacity-50">
            {busy ? 'Đang lưu…' : (mode === 'create' ? 'Tạo' : 'Lưu')}
          </button>
        </div>
      </form>
    </div>
  );
}
